import {pl} from 'date-fns/locale'
import {format, getTime, formatDistanceToNow} from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date, newFormat = undefined) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm, {locale: pl}) : '';
}

export function fDateTime(date, newFormat = undefined) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm, {locale: pl}) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
      addSuffix: true,
    })
    : '';
}
